import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 46 46"},
  viewBox: "0 0 46 46"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M28.8 21.9h-4.7v-4.7h-2.3v4.7h-4.6v2.2h4.6v4.7h2.3v-4.7h4.7z",
      class: "i-1872074525__st1"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "plus"}) } }